import { createApp } from 'vue'
import App from './App.vue'
import router from './user/router'  // 引入用户端路由
import store from './user/store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import './styles/notification.css' // 引入自定义通知样式
import GlobalChatWebSocketService from '@/user/services/globalChatService'; // 导入全局WebSocket服务
import { initWebSocketNotifications } from '@/user/services/notificationService'; // 导入WebSocket通知初始化函数

// 解决ResizeObserver loop completed with undelivered notifications错误
const debounce = (fn: (...args: any[]) => void, delay: number) => {
  let timer: any;
  return (...args: any[]) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};

// 初始化认证状态
store.dispatch('initializeAuth').finally(() => {
  // 检查用户是否已登录，如果是则连接WebSocket
  if (store.getters.isAuthenticated) {
    const token = store.state.token;
    // 只在用户端页面（非/admin路径）初始化WebSocket连接和通知
    const isUserPage = !window.location.pathname.includes('/admin');
    if (isUserPage) {
      console.log('用户已登录，且在用户端页面，尝试连接WebSocket');
      GlobalChatWebSocketService.connect(token);
      // 初始化WebSocket通知处理
      initWebSocketNotifications();
    } else {
      console.log('用户已登录，但在管理端页面，不初始化WebSocket通知');
    }
  }

  // 初始化完成后挂载应用
  createApp(App).use(store).use(router).use(ElementPlus, { locale: zhCn }).mount('#app');
});